// extracted by mini-css-extract-plugin
module.exports = {"root":"b1ddd01198--root--IuH21","left":"b1ddd01198--left--KW5l0"};